/**
 * Enum for workflow types used throughout the content management system
 * This centralizes the workflow type definitions to prevent breaking changes
 * when workflow types need to be modified or extended
 *
 * NOTE: Values must be lowercase to match backend expectations
 */
export enum WorkflowType {
  CLASSIFICATION = 'classification',
  MODERATION = 'moderation',
  REPORTS = 'reports',
  STRIKE = 'strike',
}
